import React, { useState, useEffect, useRef } from "react";
import ContractReviewSearch from "./ContractReviewSearch";
import Samples from "../sample_reporting/Samples";
import ContractReviewForm from "./ContractReviewForm";

export default function ContractReview({ laboratory_company_id }) {
  const searchFormRef = useRef({});
  const [sampleList, setSampleList] = useState(null);
  const [searchTime, setSearchTime] = useState(null);

  return (
    <div>
      <ContractReviewSearch
        onSearch={(sampleList) => {
          setSampleList(sampleList);
          setSearchTime(new Date());
        }}
        ref={searchFormRef}
        laboratory_company_id={laboratory_company_id}
      />
      {sampleList && (
        <div style={{ marginTop: 20 }}>
          <Samples
            key={searchTime}
            sample_list={sampleList}
            showAttributes={false}
            clientView={false}
            reloadData={() => searchFormRef.current.search()}
            showContractedTechniques={true}
            ToolbarComponent2={ContractReviewForm}
            view="contract_review"
          />
        </div>
      )}
    </div>
  );
}
